import { computed, ComputedRef, inject, InjectionKey, provide, WatchSource } from "vue";

const injectionKey: InjectionKey<ComputedRef> = Symbol('isMobileAppWebView');

export function provideIsMobileAppWebView(isMobileAppWebView: boolean | WatchSource<boolean>): void {
	provide(
		injectionKey,
		computed(() => {
			if (typeof isMobileAppWebView === 'boolean') {
				return isMobileAppWebView;
			}

			if (typeof isMobileAppWebView === 'function') {
				return isMobileAppWebView();
			}

			return isMobileAppWebView.value;
		})
	);
}

export function useIsMobileAppWebView(): ComputedRef<boolean> {
	return inject(injectionKey, () => computed(() => false), true);
}